import { z } from 'zod/v4';
import { BrandSchema } from './brand.js';
import { MarketSchema } from './market.js';
const _KvpsDealerIdSchema = z.string().brand();
export function isKvpsDealerId(name) {
    const matcher = RegExp(/^(?<market>[A-Z]{3})([A-Z0-9]{5})(?<brand>[A-Z])$/).exec(name);
    const market = matcher?.groups?.market;
    const brand = matcher?.groups?.brand;
    return !!matcher && MarketSchema.safeParse(market).success && BrandSchema.safeParse(brand).success;
}
export const KvpsDealerIdSchema = _KvpsDealerIdSchema.refine(isKvpsDealerId, {
    error: (data) => `Not a valid KvpsDealerId: "${data.input}"`,
});
export function getBrand(dealerId) {
    return BrandSchema.parse(dealerId.substring(8, 9));
}
export function getMarket(dealerId) {
    return MarketSchema.parse(dealerId.substring(0, 3));
}
//# sourceMappingURL=kvpsDealer.js.map